import doctor1 from "./doctor1.jpg";
import feature1 from "./feature1_doctor.jpg";
import feature2 from "./feature3_medicine.jpeg";
import feature3 from "./feature2_model.jpg";
import appStore from "./app_store.png";
import playStore from "./play_store.png";
import asthma from "./Asthma.jpg";
import diabetes from "./Diabetes.jpg";
import breastCancer from "./BreastCancer.jpg";
import heartDisease from "./HeartDisease.jpg";
import stroke from "./Stroke.jpg";
import thyroidDisease from "./ThyroidDisease.jpg";
import kidneyDisease from "./ChronicKidneyDisease.jpg";
import anaemia from "./Anaemia.jpg";
import modelSectionImage from "./modelSectionImage.jpg";
import AnasAhmed from './Doctor 01.jpg';
import DrRobertMitchell from './Doctor 02.jpg';
import DrGitaDevi from './Doctor 17.jpg';
import Cancel_Icon from './cross_icon.png';
import register from './register.png';
import sidebarImg from './SidebarImg.png';
import backgroundVideo from './backgroundVideo.mp4';
import medicineShopIcon from './medicineShopIcon.png';
import medicineShop from './medicineShop.jpg';
import Glimepiride from './Glimepiride.jpg';
import Metformine from './Metformine.jpg';
import Insulin_Glargine from './Insulin Glargine.jpg';
import Sitagliptin from './Sitagliptin.jpg';
import Dapagliflozin from './Dapagliflozin.jpg';
import Enalapril from './Enalapril.jpg';
import Hydrochlorothiazide from './Hydrochlorothiazide.jpg';
import Losartan from './Losartan.jpg';
import Metoprolol from './Metoprolol.jpeg';
import Amlodipine from './Amlodipine.jpg';
import appointment_img from './appointment_img.png';
import group_profiles from './group_profiles.png'
import Cetirizine from './Cetirizine.jpg';
import Chlorpheniramine from './Chlorpheniramine.jpg';
import Dextromethorphan from './Dextromethorphan.jpg';
import Phenylephrine from './Phenylephrine.jpg';
import Paracetamol from './Paracetamol.jpg';
import login_img from './login_image.jpg';
import role_img from './role_image.jpg';
import Pediatricians from './Pediatricians.svg';
import Neurologist from './Neurologist.svg';
import Gynecologist from './Gynecologist.svg';
import General_physician from './General_physician.svg';
import Gastroenterologist from './Gastroenterologist.svg';
import Dermatologist from './Dermatologist.svg';
import about_image from "./about_image.png";
import doc1 from "./doc1.png";
import doc2 from "./doc2.png";
import doc3 from "./doc3.png";
import doc4 from "./doc4.png";
import doc5 from "./doc5.png";
import doc6 from "./doc6.png";
import doc7 from "./doc7.png";
import doc8 from "./doc8.png";
import doc9 from "./doc9.png";
import doc10 from "./doc10.png";
import doc11 from "./doc11.png";
import doc12 from "./doc12.png";
import doc13 from "./doc13.png";
import doc14 from "./doc14.png";
import doc15 from "./doc15.png";
import menu_icon from "./menu_icon.svg";
import contact_img from "./contact_image.png"
import hospital from "./hospital.jpg"
import healthcare_logo from "./healthcare_logo.png";
import health_logo from "./health_logo.jpg"
import DoctorChatbot from "./DoctorChatbot.png";
import AnimatedDoctor from "./animated_doctor.mp4";


export const speciality_data = [
  {
    speciality: "General physician",
    image: General_physician
  },
  {
    speciality: "Gynecologist",
    image: Gynecologist
  },
  {
    speciality: "Dermatologist",
    image: Dermatologist
  },
  {
    speciality: "Pediatrician",
    image: Pediatricians
  },
  {
    speciality: "Neurologist",
    image: Neurologist
  }
]
export const images = {
  doctor1,
  appStore,
  playStore,
  modelSectionImage,
  Cancel_Icon,
  register,
  sidebarImg,
  backgroundVideo,
  medicineShopIcon,
  medicineShop,
  appointment_img,
  group_profiles,
  login_img,
  role_img,
  Pediatricians,
  Neurologist,
  Gynecologist,
  General_physician,
  Gastroenterologist,
  Dermatologist,
  about_image,
  doc1,
  doc2,
  doc3,
  doc4,
  doc5,
  doc6,
  doc7,
  doc8,
  doc9,
  doc10,
  doc11,
  doc12,
  doc13,
  doc14,
  doc15,
  menu_icon,
  contact_img,
  hospital,
  healthcare_logo,
  health_logo,
  DoctorChatbot,
  AnimatedDoctor
};

export const model_list = {
  asthma: {
    title: "Asthma Prediction",
    description: [
      "Predicts the likelihood of asthma attacks based on symptoms and medical history.",
      "Helps in early detection and management of asthma.",
      "Reduces the risk of severe asthma attacks by providing timely alerts.",
    ],
    img: asthma,
  },
  diabetes: {
    title: "Diabetes Prediction",
    description: [
      "Accurately predicts the risk of developing diabetes.",
      "Provides personalized health recommendations to prevent diabetes.",
      "Assists in monitoring blood glucose levels and managing diet.",
    ],
    img: diabetes,
  },
  breastCancer: {
    title: "Breast Cancer Prediction",
    description: [
      "Detects early signs of breast cancer using advanced algorithms.",
      "Increases chances of successful treatment through early intervention.",
      "Provides a non-invasive method to assess cancer risk.",
    ],
    img: breastCancer,
  },
  heartDisease: {
    title: "Heart Disease Prediction",
    description: [
      "Identifies risk factors for heart disease through comprehensive analysis.",
      "Helps in preventing heart attacks by providing early warnings.",
      "Guides patients in making heart-healthy lifestyle changes.",
    ],
    img: heartDisease,
  },
  stroke: {
    title: "Stroke Prediction",
    description: [
      "Predicts the risk of stroke by analyzing medical history and lifestyle factors.",
      "Enables timely intervention to prevent strokes.",
      "Supports the creation of personalized stroke prevention plans.",
    ],
    img: stroke,
  },
  thyroidDisease: {
    title: "Thyroid Disease Prediction",
    description: [
      "Assesses the risk of thyroid disorders such as hypothyroidism and hyperthyroidism.",
      "Monitors thyroid function to provide timely medical advice.",
      "Reduces the risk of complications by ensuring early detection.",
    ],
    img: thyroidDisease,
  },
  kidneyDisease: {
    title: "Chronic Kidney Disease Prediction",
    description: [
      "Detects early signs of chronic kidney disease (CKD).",
      "Helps in slowing the progression of CKD through early diagnosis.",
      "Offers guidance on managing kidney health and preventing kidney failure.",
    ],
    img: kidneyDisease,
  },
  anaemia: {
    title: "Anaemia Prediction",
    description: [
      "Predicts the likelihood of developing anaemia based on health data.",
      "Recommends dietary and lifestyle changes to prevent anaemia.",
      "Assists in the early detection and treatment of anaemia.",
    ],
    img: anaemia,
  },
};

export const feature_list = [
  {
    title: "Find Doctor",
    subtitle: "We provide you the best doctor and their details.",
    img: feature1,
  },
  {
    title: "Get Medicines",
    subtitle:
      "We provide you with the best quality medicines at affordable prices",
    img: feature2,
  },
  {
    title: "Predict Diseases",
    subtitle: "Avalability of accurate ML and DL models for disease prediction",
    img: feature3,
  },
  {
    title: "Ask Your Question",
    subtitle: "Frequent response to your query",
    img: feature2,
  },
];

export const features = [
  {
    title: "Doctor Booking System",
    description:
      "Book appointments online with ease, make secure payments, and receive a token to save time at the clinic.",
    image: feature1,
  },
  {
    title: "Online Medicine Shop",
    description:
      "Purchase medicines online with home delivery options and easy payment methods.",
    image: feature2,
  },
  {
    title: "Disease Prediction Model",
    description:
      "Leverage advanced machine learning and deep learning models for highly accurate disease prediction.",
    image: feature3,
  },
];
export const AllHospitals = [
  {
    hospitalId: 1,
    name: "Shanti Multispeciality Hospital",
    address: "123 MG Road, Hyderabad, India",
    contact: "+91 98765 43210",
    rating: 4.7
  },
  {
    hospitalId: 2,
    name: "Vivekanand Medical Centre",
    address: "45 FC Road, Pune, India",
    contact: "+91 91234 56789",
    rating: 4.6
  },
  {
    hospitalId: 3,
    name: "Little Steps Children's Hospital",
    address: "78 Whitefield, Bangalore, India",
    contact: "+91 87654 32109",
    rating: 4.8
  },
  {
    hospitalId: 4,
    name: "Metro Care Hospital",
    address: "56 Park Street, Kolkata, India",
    contact: "+91 99887 77665",
    rating: 4.5
  },
  {
    hospitalId: 5,
    name: "Sunrise Super Speciality Hospital",
    address: "32 Green Avenue, Mumbai, India",
    contact: "+91 88992 55441",
    rating: 4.6
  },
  {
    hospitalId: 6,
    name: "Apollo Health City",
    address: "Apollo Road, Chennai, India",
    contact: "+91 90001 22334",
    rating: 4.9
  },
  {
    hospitalId: 7,
    name: "City Heart Institute",
    address: "90 Nehru Nagar, Delhi, India",
    contact: "+91 77665 44332",
    rating: 4.8
  },
  {
    hospitalId: 8,
    name: "Harmony General Hospital",
    address: "23 MG Road, Jaipur, India",
    contact: "+91 99887 66754",
    rating: 4.5
  },
  {
    hospitalId: 9,
    name: "Care & Cure Medical Centre",
    address: "45 Old Town, Lucknow, India",
    contact: "+91 88990 55442",
    rating: 4.4
  },
  {
    hospitalId: 10,
    name: "Tranquil Mind Psychiatric Hospital",
    address: "12 Peace Street, Chandigarh, India",
    contact: "+91 77665 43210",
    rating: 4.7
  },
  {
    hospitalId: 11,
    name: "Green Life Orthopedic Hospital",
    address: "66 West Avenue, Ahmedabad, India",
    contact: "+91 66554 99887",
    rating: 4.6
  },
  {
    hospitalId: 12,
    name: "Lotus Women’s Care Hospital",
    address: "19 Lotus Lane, Bengaluru, India",
    contact: "+91 77662 33211",
    rating: 4.9
  },
  {
    hospitalId: 13,
    name: "Serenity Skin & Aesthetic Clinic",
    address: "7A Fashion Street, Surat, India",
    contact: "+91 66554 44321",
    rating: 4.5
  },
  {
    hospitalId: 14,
    name: "Elite Eye Care Hospital",
    address: "5 Vision Road, Nagpur, India",
    contact: "+91 77889 33221",
    rating: 4.7
  },
  {
    hospitalId: 15,
    name: "Golden Age Geriatric Hospital",
    address: "88 Retirement Lane, Coimbatore, India",
    contact: "+91 99880 55677",
    rating: 4.6
  },
  {
    hospitalId: 16,
    name: "Nova Kidney & Urology Centre",
    address: "102 Kidney Lane, Bhopal, India",
    contact: "+91 90909 88776",
    rating: 4.8
  },
  {
    hospitalId: 17,
    name: "Healing Touch Rehabilitation Centre",
    address: "22 Wellness Avenue, Indore, India",
    contact: "+91 77766 55443",
    rating: 4.5
  },
  {
    hospitalId: 18,
    name: "Summit Trauma & Emergency Hospital",
    address: "67 Rescue Road, Patna, India",
    contact: "+91 88899 11223",
    rating: 4.7
  }
];

export const doctors = [
  {
    _id: "1",
    name: "Dr. Sarah Khan",
    img: doc1,
    specialization: "General physician",
    degree: "MBBS",
    experience: 12,
    about: "Dr. Sarah Khan is a renowned oncologist with over a decade of experience in cancer treatment. She specializes in personalized chemotherapy and immunotherapy. Her compassionate care and innovative methods have earned her widespread recognition. Dr. Khan has worked with top hospitals and published research in oncology journals. She is passionate about educating patients on cancer awareness. Her clinic in Hyderabad serves patients from across the country.",
    fee: 150,
    address: {
      line1: "Cross Road",
      line2: "Uditnagar"
    },
    success_rate: 93,
    hospitalId: 6,
    hospitalName: "Shanti Multispeciality Hospital"
  },
  {
    _id: "2",
    name: "Dr. Sumit",
    img: doc1,
    specialization: "General physician",
    degree: "MBBS",
    experience: 12,
    about: "Dr. Sumit has extensive experience in treating common medical conditions and promoting preventive healthcare. His friendly demeanor makes him popular among patients.",
    fee: 150,
    address: {
      line1: "Main Street",
      line2: "Hyderabad"
    },
    success_rate: 93,
    hospitalId: 6,
    hospitalName: "Shanti Multispeciality Hospital"
  },
  {
    _id: "3",
    name: "Dr. Adarsh",
    img: doc1,
    specialization: "Gynecologist",
    degree: "MBBS",
    experience: 12,
    about: "Dr. Adarsh is an experienced gynecologist with expertise in prenatal care and women's health.",
    fee: 150,
    address: {
      line1: "Lotus Avenue",
      line2: "Hyderabad"
    },
    success_rate: 93,
    hospitalId: 6,
    hospitalName: "Shanti Multispeciality Hospital"
  },
  {
    _id: "4",
    name: "Dr. Vikram Singh",
    img: doc3,
    specialization: "Neurologist",
    degree: "MBBS",
    experience: 20,
    about: "Dr. Vikram Singh specializes in advanced neurological care with a focus on stroke recovery and brain disorders.",
    fee: 200,
    address: {
      line1: "Park Street",
      line2: "Pune"
    },
    success_rate: 97,
    hospitalId: 2,
    hospitalName: "Vivekanand Medical Centre"
  },
  {
    _id: "5",
    name: "Dr. Meera Sharma",
    img: doc2,
    specialization: "Pediatrician",
    degree: "MBBS",
    experience: 10,
    about: "Dr. Meera Sharma is a dedicated pediatrician with a focus on preventive care and childhood wellness.",
    fee: 120,
    address: {
      line1: "Green Valley",
      line2: "Bangalore"
    },
    success_rate: 92,
    hospitalId: 2,
    hospitalName: "Little Steps Children's Hospital"
  },
  {
    _id: "6",
    name: "Dr. Arjun Patel",
    img: doc4,
    specialization: "Neurologist",
    degree: "MBBS",
    experience: 18,
    about: "Dr. Arjun Patel is known for his precise diagnostic skills and advanced treatment of neurological disorders.",
    fee: 180,
    address: {
      line1: "Heritage Road",
      line2: "Ahmedabad"
    },
    success_rate: 94,
    hospitalId: 2,
    hospitalName: "Sudarshan Neurocare Clinic"
  },
    {
    _id: "8",
    name: "Dr. Kavita Nair",
    img: doc5,
    specialization: "Gynecologist",
    degree: "MBBS",
    experience: 15,
    about: "Dr. Kavita Nair is a renowned gynecologist with 15 years of experience. She specializes in high-risk pregnancies, fertility treatments, and gynecological surgeries. Dr. Nair is known for her compassionate care and expertise in women's health. She has helped hundreds of women achieve healthy pregnancies. Her clinic in Kochi offers a range of services with advanced facilities. She is also actively involved in health education programs.",
    fee: 160,
    address: {
      line1: "Marine Drive",
      line2: "Kochi"
    },
    success_rate: 96,
    hospitalId: 5,
    hospitalName: "Healing Touch Rehabilitation Centre"
  },
  {
    _id: "9",
    name: "Dr. Rajesh Iyer",
    img: doc6,
    specialization: "Psychiatrist",
    degree: "MBBS",
    experience: 12,
    about: "Dr. Rajesh Iyer is a respected psychiatrist with 12 years of experience in mental health care. He specializes in treating anxiety, depression, and mood disorders. Dr. Iyer focuses on creating personalized treatment plans that include therapy and medication. His empathetic approach and focus on holistic well-being have improved many lives. He regularly conducts mental health awareness programs in Jaipur. His clinic provides a safe and supportive environment for patients.",
    fee: 130,
    address: {
      line1: "Pink City Road",
      line2: "Jaipur"
    },
    success_rate: 91,
    hospitalId: 6,
    hospitalName: "Healing Touch Rehabilitation Centre"
  },
  {
    _id: "10",
    name: "Dr. Pooja Verma",
    img: doc11,
    specialization: "Dermatologist",
    degree: "MBBS",
    experience: 9,
    about: "Dr. Pooja Verma is an experienced ENT specialist with expertise in treating ear, nose, and throat conditions. She specializes in sinusitis treatments, hearing loss management, and tonsil surgeries. Dr. Verma is committed to providing accurate diagnoses and minimally invasive treatments. Her approachable nature makes her a favorite among patients. She regularly attends workshops to stay updated on the latest treatments. Her clinic in Lucknow offers advanced ENT care.",
    fee: 100,
    address: {
      line1: "Hazratganj",
      line2: "Lucknow"
    },
    success_rate: 89,
    hospitalId: 6,
    hospitalName: "Healing Touch Rehabilitation Centre"
  },
  {
    _id: "11",
    name: "Dr. Sanjay Gupta",
    img: doc8,
    specialization: "Cardiologist",
    degree: "MBBS, MD",
    experience: 22,
    about: "Dr. Sanjay Gupta is a veteran cardiologist with over 22 years of experience. He specializes in diagnosing and treating complex heart diseases, including angioplasty and bypass surgery. Dr. Gupta is known for his precision and commitment to saving lives. He has worked in leading cardiac care centers and contributed to heart disease research. His clinic in Patna provides cutting-edge cardiac treatments. He regularly educates patients on preventive heart care.",
    fee: 220,
    address: {
      line1: "Kankarbagh",
      line2: "Patna"
    },
    success_rate: 98,
    hospitalId: 10,
    hospitalName: "Summit Trauma & Emergency Hospital"
  },
  {
    _id: "12",
    name: "Dr. Neha Kapoor",
    img: doc9,
    specialization: "Radiologist",
    degree: "MBBS, MD",
    experience: 11,
    about: "Dr. Neha Kapoor is an expert radiologist with 11 years of experience in medical imaging. She specializes in MRI, CT scans, and ultrasound diagnostics. Dr. Kapoor is known for her accuracy in interpreting medical images and collaborating with other specialists. Her commitment to patient care ensures timely and accurate diagnoses. She has worked in leading hospitals in Indore. Her imaging center is equipped with state-of-the-art technology.",
    fee: 140,
    address: {
      line1: "Rajwada",
      line2: "Indore"
    },
    success_rate: 92,
    hospitalId: 10,
    hospitalName: "Summit Trauma & Emergency Hospital"
  },
  {
    _id: "13",
    name: "Dr. Meera Sharma",
    img: doc12,
    specialization: "Neurologist",
    degree: "MBBS, DM",
    experience: 18,
    about: "Dr. Meera Sharma is a leading neurologist with 18 years of experience in diagnosing and treating brain and nerve disorders. She specializes in stroke management, epilepsy treatment, and migraine care. Dr. Sharma has been praised for her innovative approach and patient-centered care. Her clinic in Delhi provides advanced neurological treatments with state-of-the-art technology.",
    fee: 200,
    address: {
      line1: "Connaught Place",
      line2: "Delhi"
    },
    success_rate: 97,
    hospitalId: 12,
    hospitalName: "Apollo Neurology Centre"
  }
];




export const doctor_specializations = [
  { name: "Oncologist" },
  { name: "Orthopedic Surgeon" },
  { name: "Pediatrician" },
  { name: "Neurologist" },
  { name: "Gynecologist" },
  { name: "Psychiatrist" },
  { name: "ENT Specialist" },
  { name: "Cardiologist" },
  { name: "Radiologist" },
  { name: "Gastroenterologist" }
];



export const medicine_categories = [
  { name: "Diabetes" },
  { name: "Hypertension" },
  { name: "Cold" },
  { name: "Heart Disease" },
  { name: "Allergies" },
  { name: "Asthma" },
  { name: "Arthritis" },
  { name: "Skin Conditions" },
  { name: "Infections" },
  { name: "Gastrointestinal Issues" },
  { name: "Thyroid Disorders" },
  { name: "Mental Health" },
  { name: "Pain Management" },
  { name: "Fever" },
  { name: "Vitamin Deficiencies" },
  { name: "Kidney Disorders" },
  { name: "Liver Disorders" },
  { name: "Neurological Disorders" },
  { name: "Cancer" },
  { name: "Eye Care" },
];








export const medicines = [
  // Diabetes
  {
    name: "Metformin",
    category: "Diabetes",
    price: 150,
    image: Metformine,
    description: "Helps lower blood sugar by improving insulin sensitivity.",
  },
  {
    name: "Glimepiride",
    category: "Diabetes",
    price: 200,
    image: Glimepiride,
    description: "Stimulates insulin release to manage blood sugar levels.",
  },
  {
    name: "Insulin Glargine",
    category: "Diabetes",
    price: 600,
    image: Insulin_Glargine,
    description: "A long-acting insulin to maintain glucose levels throughout the day.",
  },
  {
    name: "Sitagliptin",
    category: "Diabetes",
    price: 450,
    image: Sitagliptin,
    description: "Increases insulin release and reduces glucose production.",
  },
  {
    name: "Dapagliflozin",
    category: "Diabetes",
    price: 500,
    image: Dapagliflozin,
    description: "Helps kidneys remove excess sugar through urine.",
  },
  // Hypertension
  {
    name: "Amlodipine",
    category: "Hypertension",
    price: 120,
    image: Amlodipine,
    description: "Relaxes blood vessels to lower blood pressure.",
  },
  {
    name: "Losartan",
    category: "Hypertension",
    price: 140,
    image: Losartan,
    description: "Blocks receptors to reduce blood pressure and protect the heart.",
  },
  {
    name: "Hydrochlorothiazide",
    category: "Hypertension",
    price: 100,
    image: Hydrochlorothiazide,
    description: "A diuretic used to control blood pressure by reducing water retention.",
  },
  {
    name: "Enalapril",
    category: "Hypertension",
    price: 180,
    image: Enalapril,
    description: "An ACE inhibitor that relaxes blood vessels.",
  },
  {
    name: "Metoprolol",
    category: "Hypertension",
    price: 200,
    image: Metoprolol,
    description: "Slows heart rate to manage high blood pressure effectively.",
  },
  // Cold
  {
    name: "Paracetamol",
    category: "Cold",
    price: 50,
    image: Paracetamol,
    description: "Relieves fever and mild cold symptoms.",
  },
  {
    name: "Cetirizine",
    category: "Cold",
    price: 80,
    image: Cetirizine,
    description: "Reduces allergy-related cold symptoms such as a runny nose.",
  },
  {
    name: "Phenylephrine",
    category: "Cold",
    price: 70,
    image: Phenylephrine,
    description: "Decongests nasal passages for cold relief.",
  },
  {
    name: "Chlorpheniramine",
    category: "Cold",
    price: 90,
    image: Chlorpheniramine,
    description: "Eases sneezing and runny nose associated with the common cold.",
  },
  {
    name: "Dextromethorphan",
    category: "Cold",
    price: 120,
    image: Dextromethorphan,
    description: "Suppresses cough during colds and mild throat infections.",
  },
  // Heart Disease
  {
    name: "Aspirin",
    category: "Heart Disease",
    price: 60,
    image: "https://via.placeholder.com/150/heart/aspirin.jpg",
    description: "Prevents blood clots and reduces heart attack risks.",
  },
  {
    name: "Atorvastatin",
    category: "Heart Disease",
    price: 250,
    image: "https://via.placeholder.com/150/heart/atorvastatin.jpg",
    description: "Lowers cholesterol levels to protect heart health.",
  },
  {
    name: "Clopidogrel",
    category: "Heart Disease",
    price: 300,
    image: "https://via.placeholder.com/150/heart/clopidogrel.jpg",
    description: "Prevents blood clots in patients with heart disease.",
  },
  {
    name: "Carvedilol",
    category: "Heart Disease",
    price: 200,
    image: "https://via.placeholder.com/150/heart/carvedilol.jpg",
    description: "A beta-blocker that improves heart function.",
  },
  {
    name: "Digoxin",
    category: "Heart Disease",
    price: 220,
    image: "https://via.placeholder.com/150/heart/digoxin.jpg",
    description: "Strengthens heart contractions for better blood circulation.",
  },
  // Allergies
  {
    name: "Loratadine",
    category: "Allergies",
    price: 100,
    image: "https://via.placeholder.com/150/allergy/loratadine.jpg",
    description: "Relieves allergy symptoms such as sneezing and itchy eyes.",
  },
  {
    name: "Fexofenadine",
    category: "Allergies",
    price: 150,
    image: "https://via.placeholder.com/150/allergy/fexofenadine.jpg",
    description: "Treats seasonal allergies and hives effectively.",
  },
  {
    name: "Diphenhydramine",
    category: "Allergies",
    price: 90,
    image: "https://via.placeholder.com/150/allergy/diphenhydramine.jpg",
    description: "An antihistamine for relief from severe allergic reactions.",
  },
  {
    name: "Montelukast",
    category: "Allergies",
    price: 180,
    image: "https://via.placeholder.com/150/allergy/montelukast.jpg",
    description: "Prevents asthma symptoms triggered by allergies.",
  },
  {
    name: "Cetirizine",
    category: "Allergies",
    price: 80,
    image: "https://via.placeholder.com/150/allergy/cetirizine.jpg",
    description: "Alleviates sneezing and itching caused by allergens.",
  },

  {
    name: "Salbutamol",
    category: "Asthma",
    price: 150,
    image: "https://via.placeholder.com/150/asthma/salbutamol.jpg",
    description: "Provides quick relief from asthma symptoms by relaxing airways.",
  },
  {
    name: "Budesonide",
    category: "Asthma",
    price: 250,
    image: "https://via.placeholder.com/150/asthma/budesonide.jpg",
    description: "Reduces airway inflammation to control asthma long-term.",
  },
  {
    name: "Montelukast",
    category: "Asthma",
    price: 200,
    image: "https://via.placeholder.com/150/asthma/montelukast.jpg",
    description: "Prevents asthma attacks triggered by allergens or exercise.",
  },
  {
    name: "Theophylline",
    category: "Asthma",
    price: 300,
    image: "https://via.placeholder.com/150/asthma/theophylline.jpg",
    description: "Relaxes airway muscles to improve breathing in asthma patients.",
  },
  {
    name: "Fluticasone",
    category: "Asthma",
    price: 280,
    image: "https://via.placeholder.com/150/asthma/fluticasone.jpg",
    description: "A corticosteroid inhaler to prevent asthma symptoms.",
  },

  // Arthritis
  {
    name: "Ibuprofen",
    category: "Arthritis",
    price: 120,
    image: "https://via.placeholder.com/150/arthritis/ibuprofen.jpg",
    description: "Relieves pain and inflammation caused by arthritis.",
  },
  {
    name: "Celecoxib",
    category: "Arthritis",
    price: 220,
    image: "https://via.placeholder.com/150/arthritis/celecoxib.jpg",
    description: "A COX-2 inhibitor to reduce arthritis-related pain.",
  },
  {
    name: "Methotrexate",
    category: "Arthritis",
    price: 350,
    image: "https://via.placeholder.com/150/arthritis/methotrexate.jpg",
    description: "A disease-modifying agent for rheumatoid arthritis.",
  },
  {
    name: "Sulfasalazine",
    category: "Arthritis",
    price: 300,
    image: "https://via.placeholder.com/150/arthritis/sulfasalazine.jpg",
    description: "Reduces joint inflammation in rheumatoid arthritis.",
  },
  {
    name: "Prednisone",
    category: "Arthritis",
    price: 180,
    image: "https://via.placeholder.com/150/arthritis/prednisone.jpg",
    description: "A corticosteroid used to manage arthritis flare-ups.",
  },

  // Skin Conditions
  {
    name: "Hydrocortisone",
    category: "Skin Conditions",
    price: 90,
    image: "https://via.placeholder.com/150/skin/hydrocortisone.jpg",
    description: "Treats rashes and inflammation caused by skin conditions.",
  },
  {
    name: "Clobetasol",
    category: "Skin Conditions",
    price: 200,
    image: "https://via.placeholder.com/150/skin/clobetasol.jpg",
    description: "A potent steroid cream for severe skin disorders.",
  },
  {
    name: "Ketoconazole",
    category: "Skin Conditions",
    price: 150,
    image: "https://via.placeholder.com/150/skin/ketoconazole.jpg",
    description: "Antifungal cream for treating fungal skin infections.",
  },
  {
    name: "Tacrolimus",
    category: "Skin Conditions",
    price: 400,
    image: "https://via.placeholder.com/150/skin/tacrolimus.jpg",
    description: "An immunosuppressant cream for eczema and dermatitis.",
  },
  {
    name: "Mupirocin",
    category: "Skin Conditions",
    price: 250,
    image: "https://via.placeholder.com/150/skin/mupirocin.jpg",
    description: "An antibiotic ointment for bacterial skin infections.",
  },

  // Infections
  {
    name: "Amoxicillin",
    category: "Infections",
    price: 150,
    image: "https://via.placeholder.com/150/infections/amoxicillin.jpg",
    description: "A broad-spectrum antibiotic for bacterial infections.",
  },
  {
    name: "Azithromycin",
    category: "Infections",
    price: 200,
    image: "https://via.placeholder.com/150/infections/azithromycin.jpg",
    description: "Treats respiratory and skin infections effectively.",
  },
  {
    name: "Ciprofloxacin",
    category: "Infections",
    price: 220,
    image: "https://via.placeholder.com/150/infections/ciprofloxacin.jpg",
    description: "An antibiotic used to treat urinary tract infections.",
  },
  {
    name: "Metronidazole",
    category: "Infections",
    price: 180,
    image: "https://via.placeholder.com/150/infections/metronidazole.jpg",
    description: "Treats anaerobic bacterial and parasitic infections.",
  },
  {
    name: "Clindamycin",
    category: "Infections",
    price: 250,
    image: "https://via.placeholder.com/150/infections/clindamycin.jpg",
    description: "Used for severe bacterial infections, including skin infections.",
  },
  // Gastrointestinal Issues
  {
    name: "Omeprazole",
    category: "Gastrointestinal Issues",
    price: 100,
    image: "https://via.placeholder.com/150/gastrointestinal/omeprazole.jpg",
    description: "Reduces stomach acid for conditions like GERD.",
  },
  {
    name: "Ranitidine",
    category: "Gastrointestinal Issues",
    price: 80,
    image: "https://via.placeholder.com/150/gastrointestinal/ranitidine.jpg",
    description: "Treats and prevents ulcers in the stomach and intestines.",
  },
  {
    name: "Loperamide",
    category: "Gastrointestinal Issues",
    price: 50,
    image: "https://via.placeholder.com/150/gastrointestinal/loperamide.jpg",
    description: "Provides relief from diarrhea by slowing gut movement.",
  },
  {
    name: "Mesalamine",
    category: "Gastrointestinal Issues",
    price: 300,
    image: "https://via.placeholder.com/150/gastrointestinal/mesalamine.jpg",
    description: "Reduces inflammation in ulcerative colitis patients.",
  },
  {
    name: "Domperidone",
    category: "Gastrointestinal Issues",
    price: 120,
    image: "https://via.placeholder.com/150/gastrointestinal/domperidone.jpg",
    description: "Helps with nausea and promotes digestion.",
  },

  // Thyroid Disorders
  {
    name: "Levothyroxine",
    category: "Thyroid Disorders",
    price: 150,
    image: "https://via.placeholder.com/150/thyroid/levothyroxine.jpg",
    description: "Hormone replacement for hypothyroidism treatment.",
  },
  {
    name: "Methimazole",
    category: "Thyroid Disorders",
    price: 200,
    image: "https://via.placeholder.com/150/thyroid/methimazole.jpg",
    description: "Used to manage hyperthyroidism by reducing hormone levels.",
  },
  {
    name: "Propylthiouracil",
    category: "Thyroid Disorders",
    price: 250,
    image: "https://via.placeholder.com/150/thyroid/propylthiouracil.jpg",
    description: "Treats overactive thyroid in patients with hyperthyroidism.",
  },
  {
    name: "Liothyronine",
    category: "Thyroid Disorders",
    price: 180,
    image: "https://via.placeholder.com/150/thyroid/liothyronine.jpg",
    description: "Provides active thyroid hormone replacement.",
  },
  {
    name: "Thyroid Extract",
    category: "Thyroid Disorders",
    price: 220,
    image: "https://via.placeholder.com/150/thyroid/thyroid-extract.jpg",
    description: "A natural thyroid hormone for hypothyroidism.",
  },

  // Mental Health
  {
    name: "Fluoxetine",
    category: "Mental Health",
    price: 150,
    image: "https://via.placeholder.com/150/mental/fluoxetine.jpg",
    description: "An antidepressant to treat depression and anxiety disorders.",
  },
  {
    name: "Sertraline",
    category: "Mental Health",
    price: 180,
    image: "https://via.placeholder.com/150/mental/sertraline.jpg",
    description: "Helps with anxiety, depression, and OCD symptoms.",
  },
  {
    name: "Lorazepam",
    category: "Mental Health",
    price: 250,
    image: "https://via.placeholder.com/150/mental/lorazepam.jpg",
    description: "Provides relief from severe anxiety and panic disorders.",
  },
  {
    name: "Risperidone",
    category: "Mental Health",
    price: 300,
    image: "https://via.placeholder.com/150/mental/risperidone.jpg",
    description: "Used to manage schizophrenia and bipolar disorders.",
  },
  {
    name: "Clozapine",
    category: "Mental Health",
    price: 350,
    image: "https://via.placeholder.com/150/mental/clozapine.jpg",
    description: "Treats resistant schizophrenia in mental health patients.",
  },

  // Pain Management
  {
    name: "Paracetamol",
    category: "Pain Management",
    price: 50,
    image: "https://via.placeholder.com/150/pain/paracetamol.jpg",
    description: "Relieves mild to moderate pain and fever.",
  },
  {
    name: "Tramadol",
    category: "Pain Management",
    price: 180,
    image: "https://via.placeholder.com/150/pain/tramadol.jpg",
    description: "Treats moderate to severe pain effectively.",
  },
  {
    name: "Diclofenac",
    category: "Pain Management",
    price: 150,
    image: "https://via.placeholder.com/150/pain/diclofenac.jpg",
    description: "Provides relief from inflammation and pain.",
  },
  {
    name: "Codeine",
    category: "Pain Management",
    price: 220,
    image: "https://via.placeholder.com/150/pain/codeine.jpg",
    description: "An opioid painkiller for severe pain management.",
  },
  {
    name: "Ibuprofen",
    category: "Pain Management",
    price: 100,
    image: "https://via.placeholder.com/150/pain/ibuprofen.jpg",
    description: "Reduces inflammation and alleviates pain.",
  },
  // Fever
  {
    name: "Paracetamol",
    category: "Fever",
    price: 60,
    image: "https://via.placeholder.com/150/fever/paracetamol.jpg",
    description: "A common antipyretic to reduce fever and alleviate pain.",
  },
  {
    name: "Aspirin",
    category: "Fever",
    price: 80,
    image: "https://via.placeholder.com/150/fever/aspirin.jpg",
    description: "Reduces fever, pain, and inflammation.",
  },
  {
    name: "Ibuprofen",
    category: "Fever",
    price: 90,
    image: "https://via.placeholder.com/150/fever/ibuprofen.jpg",
    description: "Non-steroidal anti-inflammatory drug (NSAID) to treat fever.",
  },
  {
    name: "Acetaminophen",
    category: "Fever",
    price: 100,
    image: "https://via.placeholder.com/150/fever/acetaminophen.jpg",
    description: "Used to reduce fever and provide pain relief.",
  },
  {
    name: "Nimesulide",
    category: "Fever",
    price: 120,
    image: "https://via.placeholder.com/150/fever/nimesulide.jpg",
    description: "A mild painkiller and fever reducer with anti-inflammatory properties.",
  },

  // Vitamin Deficiencies
  {
    name: "Vitamin D3",
    category: "Vitamin Deficiencies",
    price: 250,
    image: "https://via.placeholder.com/150/vitamin/vitamin-d3.jpg",
    description: "Helps treat vitamin D deficiency and promotes calcium absorption.",
  },
  {
    name: "Folic Acid",
    category: "Vitamin Deficiencies",
    price: 80,
    image: "https://via.placeholder.com/150/vitamin/folic-acid.jpg",
    description: "Prevents folate deficiency and promotes healthy fetal development.",
  },
  {
    name: "Vitamin B12",
    category: "Vitamin Deficiencies",
    price: 150,
    image: "https://via.placeholder.com/150/vitamin/vitamin-b12.jpg",
    description: "Used to treat vitamin B12 deficiency and boost energy.",
  },
  {
    name: "Vitamin C",
    category: "Vitamin Deficiencies",
    price: 100,
    image: "https://via.placeholder.com/150/vitamin/vitamin-c.jpg",
    description: "Helps prevent scurvy and boosts immune system function.",
  },
  {
    name: "Vitamin A",
    category: "Vitamin Deficiencies",
    price: 200,
    image: "https://via.placeholder.com/150/vitamin/vitamin-a.jpg",
    description: "Treats vitamin A deficiency and improves vision.",
  },

  // Kidney Disorders
  {
    name: "Furosemide",
    category: "Kidney Disorders",
    price: 120,
    image: "https://via.placeholder.com/150/kidney/furosemide.jpg",
    description: "A diuretic used to reduce fluid retention and treat high blood pressure.",
  },
  {
    name: "Lisinopril",
    category: "Kidney Disorders",
    price: 150,
    image: "https://via.placeholder.com/150/kidney/lisinopril.jpg",
    description: "An ACE inhibitor for managing high blood pressure and kidney diseases.",
  },
  {
    name: "Losartan",
    category: "Kidney Disorders",
    price: 200,
    image: "https://via.placeholder.com/150/kidney/losartan.jpg",
    description: "Helps in the treatment of high blood pressure and chronic kidney disease.",
  },
  {
    name: "Calcium Carbonate",
    category: "Kidney Disorders",
    price: 90,
    image: "https://via.placeholder.com/150/kidney/calcium-carbonate.jpg",
    description: "Treats low calcium levels and supports kidney health.",
  },
  {
    name: "Erythropoietin",
    category: "Kidney Disorders",
    price: 350,
    image: "https://via.placeholder.com/150/kidney/erythropoietin.jpg",
    description: "Stimulates red blood cell production in kidney disease patients.",
  },

  // Liver Disorders
  {
    name: "Silymarin",
    category: "Liver Disorders",
    price: 180,
    image: "https://via.placeholder.com/150/liver/silymarin.jpg",
    description: "A natural supplement to support liver health and detoxification.",
  },
  {
    name: "Ursodeoxycholic Acid",
    category: "Liver Disorders",
    price: 250,
    image: "https://via.placeholder.com/150/liver/ursodeoxycholic-acid.jpg",
    description: "Helps manage gallstones and liver diseases.",
  },
  {
    name: "Lactulose",
    category: "Liver Disorders",
    price: 120,
    image: "https://via.placeholder.com/150/liver/lactulose.jpg",
    description: "A laxative used to treat constipation and reduce ammonia levels in the blood.",
  },
  {
    name: "Enalapril",
    category: "Liver Disorders",
    price: 140,
    image: "https://via.placeholder.com/150/liver/enalapril.jpg",
    description: "Treats high blood pressure and protects kidney and liver functions.",
  },
  {
    name: "Diuretics",
    category: "Liver Disorders",
    price: 100,
    image: "https://via.placeholder.com/150/liver/diuretics.jpg",
    description: "Helps remove excess fluid in liver disease-related conditions.",
  },

  // Neurological Disorders
  {
    name: "Gabapentin",
    category: "Neurological Disorders",
    price: 220,
    image: "https://via.placeholder.com/150/neuro/gabapentin.jpg",
    description: "Used for nerve pain and seizures.",
  },
  {
    name: "Carbamazepine",
    category: "Neurological Disorders",
    price: 180,
    image: "https://via.placeholder.com/150/neuro/carbamazepine.jpg",
    description: "Treats epilepsy and nerve-related pain.",
  },
  {
    name: "Donepezil",
    category: "Neurological Disorders",
    price: 300,
    image: "https://via.placeholder.com/150/neuro/donepezil.jpg",
    description: "Used to treat Alzheimer's disease and improve cognition.",
  },
  {
    name: "Levodopa",
    category: "Neurological Disorders",
    price: 350,
    image: "https://via.placeholder.com/150/neuro/levodopa.jpg",
    description: "A medication used to treat Parkinson’s disease symptoms.",
  },
  {
    name: "Topiramate",
    category: "Neurological Disorders",
    price: 250,
    image: "https://via.placeholder.com/150/neuro/topiramate.jpg",
    description: "Used to treat seizures and prevent migraines.",
  },

  // Cancer
  {
    name: "Methotrexate",
    category: "Cancer",
    price: 400,
    image: "https://via.placeholder.com/150/cancer/methotrexate.jpg",
    description: "A chemotherapy drug used to treat cancer and autoimmune diseases.",
  },
  {
    name: "Cisplatin",
    category: "Cancer",
    price: 450,
    image: "https://via.placeholder.com/150/cancer/cisplatin.jpg",
    description: "Treats various types of cancer by inhibiting cancer cell growth.",
  },
  {
    name: "Doxorubicin",
    category: "Cancer",
    price: 500,
    image: "https://via.placeholder.com/150/cancer/doxorubicin.jpg",
    description: "A chemotherapy drug to treat cancers like leukemia, lymphoma, and more.",
  },
  {
    name: "Tamoxifen",
    category: "Cancer",
    price: 600,
    image: "https://via.placeholder.com/150/cancer/tamoxifen.jpg",
    description: "Used in hormone therapy for breast cancer treatment.",
  },
  {
    name: "Imatinib",
    category: "Cancer",
    price: 700,
    image: "https://via.placeholder.com/150/cancer/imatinib.jpg",
    description: "A targeted therapy used for chronic myelogenous leukemia (CML).",
  },

  // Eye Care
  {
    name: "Latanoprost",
    category: "Eye Care",
    price: 250,
    image: "https://via.placeholder.com/150/eye/latanoprost.jpg",
    description: "Treats glaucoma by reducing intraocular pressure.",
  },
  {
    name: "Timolol",
    category: "Eye Care",
    price: 150,
    image: "https://via.placeholder.com/150/eye/timolol.jpg",
    description: "Reduces pressure in the eyes, treating glaucoma.",
  },
  {
    name: "Brimonidine",
    category: "Eye Care",
    price: 300,
    image: "https://via.placeholder.com/150/eye/brimonidine.jpg",
    description: "Helps manage intraocular pressure and eye redness.",
  },
  {
    name: "Cyclosporine",
    category: "Eye Care",
    price: 350,
    image: "https://via.placeholder.com/150/eye/cyclosporine.jpg",
    description: "Treats dry eye disease by increasing tear production.",
  },
  {
    name: "Prednisolone",
    category: "Eye Care",
    price: 200,
    image: "https://via.placeholder.com/150/eye/prednisolone.jpg",
    description: "A corticosteroid used to treat inflammation in eye diseases.",
  },
];

export const medicines_for_cart = [
  {
    _id: "1",
    name: "Paracetamol",
    image: "https://via.placeholder.com/150/heart/atorvastatin.jpg",
    price: 5,
  },
  {
    _id: "2",
    name: "Amoxicillin",
    image: "https://via.placeholder.com/150/heart/atorvastatin.jpg",
    price: 12,
  },
  {
    _id: "3",
    name: "Ibuprofen",
    image: "https://via.placeholder.com/150/heart/atorvastatin.jpg",
    price: 8,
  },
  {
    _id: "4",
    name: "Cetirizine",
    image: "https://via.placeholder.com/150/heart/atorvastatin.jpg",
    price: 3,
  },
  {
    _id: "5",
    name: "Aspirin",
    image: "https://via.placeholder.com/150/heart/atorvastatin.jpg",
    price: 4,
  },
];
